import "./section-home.style.css";

const SectionHome = (props) => {
  return (
    <div className="content">
      <section>
        <h5>
          <a href="/">Hiring in hurry</a>
        </h5>
        <p>
          Find talented pros in record time with Upwork and keep business moving
        </p>
      </section>
    </div>
  );
};

export default SectionHome;
